const DatePicker = (($) => {

    const NAME = 'date';
    const DATA_KEY = `bs.${NAME}`;
    const EVENT_KEY = `.${NAME}rangepicker`;
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {
        autoUpdateInput: false,
        singleDatePicker: true,
        template:
            '<div class="daterangepicker dropdown-menu">' +
                '<div class="calendars">' +
                    '<div class="calendar left">' +
                        '<div class="calendar-table"></div>' +
                        '<div class="daterangepicker_input">' +
                            '<div class="calendar-time">' +
                                '<div></div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="calendar right">' +
                        '<div class="calendar-table"></div>' +
                        '<div class="daterangepicker_input">' +
                            '<div class="calendar-time">' +
                                '<div></div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="ranges">' +
                        '<div class="daterangepicker-inputs">' +
                            '<div class="daterangepicker_input">' +
                                '<span>Start Date:</span>' +
                                '<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
                                '<i class="fa fa-calendar"></i>' +
                            '</div>' +
                            '<div class="daterangepicker_input">' +
                                '<span>End Date:</span>' +
                                '<input class="input-mini form-control" type="text" name="daterangepicker_end" value="" />' +
                                '<i class="fa fa-calendar"></i>' +
                            '</div>' +
                        '</div>' +
                        '<div class="range_inputs">' +
                            '<div class="row">' +
                                '<div class="col-sm-6">' +
                                    '<button class="cancelBtn" type="button"></button>' +
                                '</div>' +
                                '<div class="col-sm-6">' +
                                    '<button class="applyBtn" disabled="disabled" type="button"></button>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>',
        applyClass: 'btn-primary',
        autoApply: false,
        buttonClasses: 'btn',
        cancelClass: 'btn-default',
        dateLimit: false,
        drops: 'down',
        endDate: false,
        locale: {
            direction: 'ltr',
            format: 'MM/DD/YYYY',
            separator: ' - ',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            weekLabel: 'W'
        },
        maxDate: false,
        minDate: false,
        opens: 'right',
        ranges: false,
        showCustomRangeLabel: true,
        showDropdowns: false,
        showWeekNumbers: false,
        startDate: false,
        timePicker: false,
        timePicker24Hour: false,
        timePickerIncrement: 1,
        timePickerSeconds: false
    };
    const Event = {
        APPLY: `apply${EVENT_KEY}`,
        CANCEL: `cancel${EVENT_KEY}`,
        SHOW: `show${EVENT_KEY}`
    }
    const Selector = {
        DATE: `.js-${NAME}`
    }

    class DatePicker {
        constructor(element, config) {
            this._config = config;
            this._element = element;

            $(this._element)
                .on(Event.APPLY, (ev, picker) => this._apply(ev, picker))
                .on(Event.CANCEL, (ev, picker) => this._cancel(ev, picker))
                .on(Event.SHOW, (ev, picker) => this._show(ev, picker));
        }

        _apply(ev, picker) {
            if (this._config.singleDatePicker) {
                $(this._element).val(`${picker.startDate.format(this._config.locale.format)}`).trigger('change');
            } else {
                $(this._element).val(`${picker.startDate.format(this._config.locale.format)}${this._config.locale.separator}${picker.endDate.format(this._config.locale.format)}`).trigger('change');
            }
        }

        _cancel(ev, picker) {
            $(this._element).val('');
        }

        _show(ev, picker) {
            this._restyle(picker.container);
            picker.container.find('.calendar')
                .on('mousedown.daterangepicker', 'td.available', () => this._restyle(picker.container))
                .on('click.daterangepicker', '.prev', () => this._restyle(picker.container))
                .on('click.daterangepicker', '.next', () => this._restyle(picker.container))
                .on('change.daterangepicker', 'select', () => this._restyle(picker.container));

            if (picker.element.offset().top - $(window).scrollTop() + picker.container.outerHeight() > $(window).height()) {
                return picker.drops = 'up';
            } else {
                return picker.drops = 'down';
            }
        }

        _restyle(container) {
            container.find('select').addClass('form-control input-xs');
            container.find('th.next .fa, th.prev .fa').removeClass('fa-chevron-left fa-chevron-right glyphicon glyphicon-chevron-left glyphicon-chevron-right').addClass('fa-lg');
            container.find('th.prev .fa').addClass(`fa-angle-${this._config.locale.direction === 'ltr' ? 'left' : 'right'}`);
            container.find('th.next .fa').addClass(`fa-angle-${this._config.locale.direction === 'ltr' ? 'right' : 'left'}`);
            container.find('.range_inputs').toggleClass('hide', container.find('.applyBtn').hasClass('hide'));
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
        }

        static _jQueryInterface() {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    data = new DatePicker(this, config);
                    $this.data(DATA_KEY, data).daterangepicker(config);
                }
            });
        }
    }
    $(() => DatePicker._jQueryInterface.call($(Selector.DATE)));
    $(document).ajaxStop(() => DatePicker._jQueryInterface.call($(Selector.DATE)));

    $.fn[NAME] = DatePicker._jQueryInterface;
    $.fn[NAME].Constructor = DatePicker;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return DatePicker._jQueryInterface;
    }

    return DatePicker;
})(jQuery);